const getCrypto = (): Crypto | undefined => {
  if (typeof globalThis.crypto !== 'undefined') {
    return globalThis.crypto;
  }

  return undefined;
};

export const base64UrlEncode = (buffer: ArrayBuffer): string => {
  const bytes = Array.from(new Uint8Array(buffer));
  const binary = bytes.map((byte) => String.fromCharCode(byte)).join('');
  const encoded = typeof btoa === 'function'
    ? btoa(binary)
    : Buffer.from(binary, 'binary').toString('base64');

  return encoded
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');
};

export const createRandomString = (byteLength = 32): string => {
  const randomBytes = new Uint8Array(byteLength);
  const webCrypto = getCrypto();

  if (!webCrypto?.getRandomValues) {
    throw new Error('Web Crypto API is required for secure random values');
  }

  webCrypto.getRandomValues(randomBytes);

  return base64UrlEncode(randomBytes.buffer);
};

export const createPkceCodeChallenge = async (codeVerifier: string): Promise<string> => {
  const webCrypto = getCrypto();

  if (!webCrypto?.subtle) {
    throw new Error('Web Crypto API is required for PKCE');
  }

  const data = new TextEncoder().encode(codeVerifier);
  const digest = await webCrypto.subtle.digest('SHA-256', data);

  return base64UrlEncode(digest);
};
